import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const RejectedContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  [theme.breakpoints.down("sm")]: {
    padding: "0",
    "& p, & span, & h1, & h2, & h3, & h4, & h5, & h6, & div": {
      wordBreak: "break-word",
      overflowWrap: "break-word",
    },
  },
}));

export const RejectedIcon = styled(Box)(({ theme }) => ({
  marginBottom: "60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    marginBottom: "24px",
  },
}));

export const RejectedTitle = styled(Typography)(({ theme }) => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "12px",
  color: "#1B252F",
  lineHeight: "36px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "18px",
    lineHeight: "26px",
    marginBottom: "12px",
  },
}));

export const RejectedSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "28px",
  marginBottom: "24px",
  maxWidth: "500px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    lineHeight: "22px",
    marginBottom: "16px",
    maxWidth: "100%",
  },
}));

export const CommentContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "500px",
  marginBottom: "60px",
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
    marginBottom: "24px",
  },
}));

export const RejectedActions = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    "& button": {
      width: "100%",
    },
  },
}));

export const SuccessMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.main,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "16px",
  fontWeight: 600,
  marginTop: "24px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    marginTop: "16px",
  },
}));
